import { Button, Upload, message } from "antd";
import PropTypes from "prop-types";

import { Types } from "scripts/settings";
import Resources from "scripts/resources";

const Component = ({ onChange, value, form }) => {
	// console.log(value);
	const handleUpload = (options) => {
		const { file } = options;
		console.log(file.type)
		if (Types.uploadFileFormats.indexOf(file.type) >= 0) {
			// if (file.size < parseInt(process.env.REACT_APP_FILE_SIZE_LIMIT)) {
				onChange(file);
			// } else {
			// 	message.error(Resources.uploadErros?.sizePdf);
			// }
		} else {
			message.error(Resources.uploadErros?.extensionFile);
		}
	};

	const uploadOpt = {
		showUploadList: false,
		customRequest: handleUpload,
	};

	return (
		<Upload {...uploadOpt}>
			<Button>{value?.name || Resources.upload}</Button>
		</Upload>
	);
};

Component.propTypes = {
	onChange: PropTypes.func,
	value: PropTypes.object,
};

export default Component;
